import React from 'react'

import {Routes, Route, Navigate} from 'react-router-dom'
const Login = React.lazy(() => import('./components/pages/auth/login'))

const Error = React.lazy(() => import('./components/pages/error/Error'))
const AddObject = React.lazy(() => import('./components/pages/private/add-object').then(m => ({default: m.AddObject})))
const Dashboard = React.lazy(() => import('./components/pages/private/dashboard').then(m => ({default: m.Dashboard})))
const Investors = React.lazy(() => import('./components/pages/private/investors/').then(m => ({default: m.Investors})))
const Clients = React.lazy(() => import('./components/pages/private/clients/').then(m => ({default: m.Clients})))
const BronClients = React.lazy(() => import('./components/pages/private/bron-clients/').then(m => ({default: m.BronClients})))
const Expenses = React.lazy(() => import('./components/pages/private/expenses').then(m => ({default: m.Expenses})))
const Staffs = React.lazy(() => import('./components/pages/private/staffs').then(m => ({default: m.Staffs})))
const Investor = React.lazy(() => import('./components/pages/private/investor').then(m => ({default: m.Investor})))
const AddInvestor = React.lazy(() => import('./components/pages/private/add-investor').then(m => ({default: m.AddInvestor})))
const EditInvestor = React.lazy(() => import('./components/pages/private/edit-investor').then(m => ({default: m.EditInvestor})))
const ObjectPage = React.lazy(() => import('./components/pages/private/object-page').then(m => ({default: m.ObjectPage})))
const BlockPage = React.lazy(() => import('./components/pages/private/block-page').then(m => ({default: m.BlockPage})))
const BlockDetails = React.lazy(() => import('./components/pages/private/block-details/block-details').then(m => ({default: m.BlockDetails})))
const Client = React.lazy(() => import('./components/pages/private/client').then(m => ({default: m.Client})))
const AddClient = React.lazy(() => import('./components/pages/private/add-client').then(m => ({default: m.AddClient})))
const EditClient = React.lazy(() => import('./components/pages/private/edit-client').then(m => ({default: m.EditClient})))
const AddStaff = React.lazy(() => import('./components/pages/private/add-staff').then(m => ({default: m.AddStaff})))
const EditStaff = React.lazy(() => import('./components/pages/private/edit-staff').then(m => ({default: m.EditStaff})))
const Accountants = React.lazy(() => import('./components/pages/private/accountants').then(m => ({default: m.Accountants})))
const AddAccountant = React.lazy(() => import('./components/pages/private/add-accountant').then(m => ({default: m.AddAccountant})))
const EditAccountant = React.lazy(() => import('./components/pages/private/edit-accountants').then(m => ({default: m.EditAccountant})))
const ClientComments = React.lazy(() => import('./components/pages/private/client-comments').then(m => ({default: m.ClientComments})))

const Approuter = () => (
  <>
    <Routes>
      <Route path="/*" element={<Error />} />
      <Route path="/" element={<Navigate to={'/login'} />} />
      <Route path="/login" element={<Login />} />
      <Route path="/add-object" element={<AddObject />} />
      <Route path="/objects/:id" element={<ObjectPage />} />
      <Route path="/objects/:id/edit-block/:blockID" element={<BlockPage />} />
      <Route path="/block-details/:id" element={<BlockDetails />} />
      <Route path="/investors" element={<Investors />} />
      <Route path="/investors/:id" element={<Investor />} />
      <Route path="/add-investor" element={<AddInvestor />} />
      <Route path="/edit-investor/:id" element={<EditInvestor />} />
      <Route path="/clients" element={<Clients />} />
      <Route path="/bron-clients" element={<BronClients />} />
      <Route path="/clients/:id" element={<Client />} />
      <Route path="/add-client" element={<AddClient />} />
      <Route path="/edit-client/:id" element={<EditClient />} />
      <Route path="/clients/:id/comments" element={<ClientComments />} />
      <Route path="/expenses" element={<Expenses />} />
      <Route path="/staffs" element={<Staffs />} />
      <Route path="/edit-staff/:id" element={<EditStaff />} />
      <Route path="/add-staff" element={<AddStaff />} />
      <Route path="/accountants" element={<Accountants />} />
      <Route path="/add-accountant" element={<AddAccountant />} />
      <Route path="/edit-accountant/:id" element={<EditAccountant />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/expenses" element={<Expenses />} />
    </Routes>
    <div className="sidebar-overlay"></div>
  </>
)

export default Approuter
